const state = {
  estadoCivils: [{value: 'Solteiro', text: 'Solteiro'}, {value: 'Casado', text: 'Casado'}],
  generos: [{value: 'M', text: 'Masculino'}, {value: 'F', text: 'Feminino'}],
  tipoTelefones: [{value: 1, text: 'RESIDENCIAL'}, {value: 2, text: 'CELULAR'}, {value: 3, text: 'COMERCIAL'}],
  tipoFornecedores: [{value: 1, text: 'ESCOLAS'}, {value: 2, text: 'OUTROS'}],
  tipoprocessos: [{value: 1, text: 'Administrativo'}, {value: 2, text: 'Jurídico'}],
  contact: [{value: null, text: ''}, {value: 1, text: 'Contatado'}, {value: 2, text: 'Concluído'}, {value: 3, text: 'Cancelado'}],
}

const getters = {
  ESTADO_CIVIL: state => state.estadoCivils,
  GENERO: state => state.generos, 
  TIPO_TELEFONES: state => state.tipoTelefones,
  TIPO_FORNECEDORES: state => state.tipoFornecedores,
  TIPOPROCESSOS: state => state.tipoprocessos,
  CONTACTS: state => state.contact,
}

export default {
  namespaced: true,
  state,
  getters,
} 


// WEBPACK FOOTER //
// ./src/store/modules/enums/index.js